import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export interface LogoProps {
  className?: string;
}

export default function Logo({ className }: LogoProps) {
  return (
    <svg
      viewBox="0 0 791.5 119.1"
      className={twMerge(classes.logo, className)}
      aria-label="witMetrics">
      <path
        fill="#f15a2b"
        d="M27,116.7L3.5,35.8h24.3l13,54.5l13-54.5h24.3l13,55.3l13-55.3h24.3l-23.5,80.9h-26L65.1,63.1l-13,53.6H27z"
      />
      <polygon
        fill="#f15a2b"
        points="160.3,35.8 132.7,35.8 166.6,116.6 195.8,116.6"
      />
      <path
        fill="#f15a2b"
        d="M206.3,92.3V56.6H189l-9.4-20.3h25.8V13.6h22.7v22.7h19.6v20.3H229v34c0,6.5,3.1,8.9,10.2,8.9c3.1,0,6.3-0.8,8.6-1.6v17.8c-3.9,0.8-9.4,1.6-14.9,1.6C214.9,117.4,206.3,108.5,206.3,92.3z"
      />
      <path
        fill="currentColor"
        d="M260.2,116.1V35.6h22.5l0.8,12.7c3.2-6.8,11.2-14.4,23.3-14.4c11.2,0,19.2,5.1,23.3,15.3c5.6-9.3,13.6-15.3,24.9-15.3c18.4,0,26.5,12.7,26.5,31.4v50.9H358V69.5c0-11-4-16.1-11.2-16.1c-8,0-12.8,5.9-12.8,19.5v43.2h-23.3V70.4c0-11-3.2-17-11.2-17s-13.6,5.9-13.6,19.5v43.2C285.9,116.1,260.2,116.1,260.2,116.1z"
      />
      <path
        fill="currentColor"
        d="M388.6,76.2v-1.7c0-23.9,16.3-40.4,40.7-40.4c26.9,0,40.7,19,39.1,47h-56.2c0.8,12.4,6.5,18.2,17.1,18.2c8.1,0,13-4.1,14.7-9.1h23.6c-4.1,16.5-17.9,27.2-38.3,27.2C404.1,117.5,388.6,101,388.6,76.2z M444,67.2c-0.8-9.1-5.7-14.9-14.7-14.9c-9.8,0-14.7,5-16.3,14.9H444z"
      />
      <path
        fill="currentColor"
        d="M485.7,91.6V56.3h-13.8V36.2h13.8V11h23.6v25.2h19.5v20.2h-19.5V90c0,6.7,3.3,9.2,10.6,9.2c3.3,0,6.5-0.8,9-1.7V116c-4.1,0.8-9.8,1.7-15.5,1.7C494.6,118.5,485.7,109.3,485.7,91.6z"
      />
      <path
        fill="currentColor"
        d="M540.8,36h22.8l0.8,15.8c3.3-9.1,10.6-16.6,22.8-16.6c1.6,0,3.3,0,4.9,0.8v23.3c-1.6,0-4.1,0-6.5,0c-13.8,0-20.4,6.7-20.4,20v37.3l-24.2-0.1L540.8,36z"
      />
      <path
        fill="currentColor"
        d="M625.7,26.7h-25.2V1.4h25.2V26.7z M625.7,36v80.6h-25.3V36H625.7z"
      />
      <path
        fill="currentColor"
        d="M633.6,77.8v-1.7c0-24.2,15.5-40.9,39.9-40.9c21.2,0,35,12.5,36.6,32.6h-23.6c-0.8-8.3-4.9-14.2-13.8-14.2c-10.6,0-14.7,8.3-14.7,21.7V77c0,14.2,4.9,22.5,14.7,22.5c9,0,13-5.8,13.8-14.2h23.6c-2.4,20-16.3,32.6-36.6,32.6C649.1,119.5,633.6,102.8,633.6,77.8z"
      />
      <path
        fill="currentColor"
        d="M715.8,90.9h22.8c0.8,6.7,6.5,10.9,13.8,10.9s11.4-2.5,11.4-7.5c0-4.2-2.4-6.7-16.3-9.2c-20.4-3.3-30.1-10-30.1-24.2c0-15,13.8-25,33.4-25c21.2,0,33.4,10,34.2,25.9h-22c-0.8-5.8-5.7-9.2-12.2-9.2s-10.6,2.5-10.6,6.7c0,4.2,3.3,5.8,15.5,7.5c21.2,3.3,31.7,10,31.7,25c0,15.8-13.8,26.7-35.8,26.7C731.3,120.5,716.6,109.3,715.8,90.9z"
      />
    </svg>
  );
}
